export default __webpack_public_path__ + "static/media/NIG.8a929386.svg";